import gql from 'graphql-tag';

export const gqlGetQuery = gql`
  query getCntContributors($where: String, $offset: Int, $limit: Int, $order: String) {
    getCntContributors(where: $where, offset: $offset, limit: $limit, order: $order) {
      data {
        id
        name
        addressLine1
        addressLine2
        addressArea
        addressCity
        postalCode
        contactPerson
        phoneNumber1
        phoneNumber2
        mobileNumber1
        email
        vatNumber
        taxOffice
        producerRegNum
        contributorGroupId
        cntContributorsGroup {
          id
          name
        }
        contributionPeriodGroupId
        cntContributionsPeriodgroup {
          id
          name
        }
        isActive
      }
      recordCount
    }
  }
`;

export const gqlGetByIdQuery = gql`
  query getCntContributorById($id: Int) {
    getCntContributorById(id: $id) {
      id
      name
      addressLine1
      addressLine2
      addressArea
      addressCity
      postalCode
      contactPerson
      phoneNumber1
      phoneNumber2
      mobileNumber1
      email
      vatNumber
      taxOffice
      producerRegNum
      contributorGroupId
      contributionPeriodGroupId
      isActive
      firstDate
      lastDate
      firstUser
      lastUser
    }
  }
`;

export const gqlAdd = gql`
  mutation addCntContributor($data: CntContributorInput) {
    addCntContributor(data: $data) {
      id
    }
  }
`;

export const gqlUpdate = gql`
  mutation updateCntContributor($data: CntContributorInput) {
    updateCntContributor(data: $data) {
      id
    }
  }
`;

export const gqlDelete = gql`
  mutation deleteCntContributor($id: Int) {
    deleteCntContributor(id: $id)
  }
`;

type Int = number;
type String = string;
type Boolean = boolean;
export class FormInput {
  id: Int;
  name: string;
  addressLine1: string;
  addressLine2: string;
  addressArea: string;
  addressCity: string;
  postalCode: string;
  contactPerson: string;
  phoneNumber1: string;
  phoneNumber2: string;
  mobileNumber1: string;
  email: string;
  vatNumber: string;
  taxOffice: string;
  producerRegNum: string;
  contributorGroupId: Int;
  contributionPeriodGroupId: Int;
  isActive: boolean;

  // insert construtor
  constructor() {
    this.id = undefined;
    this.name = undefined;
    this.addressLine1 = undefined;
    this.addressLine2 = undefined;
    this.addressArea = undefined;
    this.addressCity = undefined;
    this.postalCode = undefined;
    this.contactPerson = undefined;
    this.phoneNumber1 = undefined;
    this.phoneNumber2 = undefined;
    this.mobileNumber1 = undefined;
    this.email = undefined;
    this.vatNumber = undefined;
    this.taxOffice = undefined;
    this.producerRegNum = undefined;
    this.contributorGroupId = undefined;
    this.contributionPeriodGroupId = undefined;
    this.isActive = undefined;
  }
}
